import { getAuthToken } from '../auth/auth.helpers.js';

const authInterceptor = async (config)=>{
    const token = await getAuthToken();
    if (token) {
        /**@ts-ignore */ config.headers['Authorization'] = await getAuthToken();
    }
    return config;
};

export { authInterceptor as default };
//# sourceMappingURL=authInterceptor.js.map
